import { render } from "./ChatCard.vue?vue&type=template&id=8f55310a"
import script from "./ChatCard.vue?vue&type=script&lang=js"
export * from "./ChatCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__